import { config } from 'config';
import { ReactNode } from 'react';

const Robots = (
  robots?:
    | 'index, follow'
    | 'noindex, follow'
    | 'index, nofollow'
    | 'noindex, nofollow'
    | ''
    | undefined
    | null
): ReactNode => {
  // Set meta tag if this build is used for production traffic
  const isLive = config.isLive === 'true';

  return (
    <meta
      name="robots"
      content={isLive ? robots || 'index, follow' : 'noindex, nofollow'}
      data-test="robots-meta"
    />
  );
};

export default Robots;
